import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import ContactForm from './contactForm';
import { contactPage } from '../../../SHARED/actions/pages.actions';
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';

class Contact extends Component {
    constructor(props){
        super(props);
        this.state = {
            message: ""
        }
    }

    componentWillMount(){
        window.scrollTo(0, 0);
    }
    
    componentDidMount() {
        pageViewEvent('Contact',window.location.href);
     }

    handleSubmit = (data) => {
        const payload = {
            contact_form:[{target_id:"general"}],
            name:[{value: data.name}],
            mail:[{value: data.email}],
            subject:[{value: data.subject}],
            message:[{value: data.message}]
        }
        this.props.contactPage(payload);
        this.setState({message: "Datele au fost trimise"})
    }
    
    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Contact</title>
                    <link rel='canonical' href={window.location.href}/>
                </Helmet>
                <div className="container grey-text">
                    <div className="contact-page">
                        <ContactForm onSubmit={this.handleSubmit} message={this.state.message} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {contactPage})(Contact);





// WEBPACK FOOTER //
// ./src/FO/components/contact/contact.component.js